<template>
  <v-app id="app">
    <!--ヘッダー-->
    <Header></Header>
    <!--パンくずリスト-->
    <!--<Breadcrumbs></Breadcrumbs>-->
    <!--最上部へ戻るボタン-->
    <toTop></toTop>
    <!--コンポーネントを挿入-->
    <router-view></router-view>
    <!--フッター-->
    <Footer></Footer>
  </v-app>
</template>

<style>
@import url('https://fonts.googleapis.com/css?family=Sawarabi+Gothic&display=swap');
#app {
  font-family: 'Sawarabi Gothic';
  overflow: hidden;
}
</style>

<script>
// ヘッダー
import Header from './components/Header'
// パンくずリスト
// import Breadcrumbs from './components/Breadcrumbs'
// トップへ戻るボタン
import toTop from './components/toTop'
// フッター
import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    Header,
    toTop,
    Footer
  }
}
</script>
